import { useEffect, useState } from "react";
import { _AccountINFORPO, _Credit, _CreditProcessMovement, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean"
import { YearSelector } from "../../../../../core/shared/inputs/YearSelector";
import { SelectMonths } from "../../../../contract/select/SelectMonths";
import { AccountEditor } from "../../../../editor/AccountEditor";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../../theme/Component/BasicTable";
import useModal, { MODAL_LG } from "../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../theme/Component/Modal";
import usePaginator from "../../../../theme/Component/usePaginator";
import { toast } from "react-toastify";
import { _CreditAccountvdos } from "../../../../../core/services/dataBean/EntityCatalogVdos";

interface Props {
    idAccount: number;
    label?: string;
    onChange: any;
}

interface FilterForm {
    Year: number;
    Month: number;
    State: number | null;
    IdAccount: number;
}

export const CreditAccountEditor = ({ idAccount, label, onChange }: Props) => {

    const { instance, setBean, setLista, bean, lista } = useDataBean(_CreditAccountvdos);
    const paginador = usePaginator();
    const modalCredito = useModal("Credito", MODAL_LG);

    const [value, setValue] = useState<string>("");
    const [filters, setFilters] = useState<Partial<FilterForm>>({
        Month: _single.getCurrentMonth(),
        Year: _single.getCurrenYear(),
        State: 724,
        IdAccount: idAccount
    });

    useEffect(() => {
        if (filters.IdAccount) {
            getLista();
        } else {
            setLista([]);
            setBean({});
        }
    }, [filters.IdAccount, filters.State, filters.Month, filters.Year, paginador.page]);



    const getLista = () => {
        if (!filters.IdAccount) {
            toast.error("Usuario no válido");
            return;
        }

        const props: any = {
            IDAccount: filters.IdAccount
        };

        if (filters.State) props.State = filters.State;
        if (filters.Month) props.Month = 8;
        if (filters.Year) props.Year = filters.Year;

        instance.getCarteraRender(paginador.page, 15, props)
            .then((resp) => {
                setLista(resp.List || []);
                setBean({});
                paginador.setPages(resp.NumberOfPages || 1);
            })
            .catch((err) => toast.error(err));
    };

    const head = [
        { title: 'ID', property: 'IDCreditAccount', visible: false, mask: MASK_NUMBER },
        { title: 'Nombre', property: 'CreditNumber', visible: true },
        { title: 'Tercero', property: 'DeudorName', visible: true },
        { title: 'Valor Crédito', property: 'AmountCredit', visible: true, mask: MASK_MONEY },
        { title: 'Saldo Crédito', property: 'CurrentCapitalLeft', visible: true, mask: MASK_MONEY },
        { title: 'Linea Crédito', property: 'NameLoanLine', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
    ]

    const returnData = () => {
        if (bean.IDCreditAccount) {
            setValue(`${bean.IDCreditAccount} - ${bean.DeudorName}`)
            onChange?.(bean);
            modalCredito.close();
        } else {
            toast.error("Credito no valido");
        }
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <label>{label ?? 'Crédito'}</label>
                <input className="form-control" type="text" name="cre" readOnly value={value ?? "Buscar Créditos"} onClick={() => { modalCredito.open() }} />
                <Modal modal={modalCredito.modal} updateModal={modalCredito.setModal} eventModal={returnData}>
                    <div className="row">
                        {!idAccount &&
                            <div className="col-md-4">
                                <AccountEditor disabled={idAccount != undefined} idAccount={bean.IDAccount} label="Tercero" onChange={(e) => { setBean({ ...bean, "IDAccount": e.IDAccount }) }} />
                            </div>
                        }
                        <div className="col-md-4">
                            <BasicButton icon="" eventClick={getLista} useMargin>Buscar</BasicButton>
                        </div>
                        <div className="col-md-12">
                            <BasicTable body={lista} head={head} rowSet={setBean} records={paginador} />
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    )
}